import React, {Fragment, PureComponent} from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Button from '@/components/button/Button';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import './BottomMenu.less';

@connect((store) => ({
  // topmenu
  activeMenu: store.setupStore.activeMenu,
}))
export default class BottomMenuCommon extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  generateButton = (id, label, onClick, icon, activeButtonId, disabled) => {
    const {activeMenu} = this.props;
    if (activeButtonId !== id) {
      switch (activeMenu) {
        case APPDATA.ADVANCED_SETUP_NEW:
          return (
            <div
              className={`${APPSTYLE.COLUMN_1}colButtonBottomMenuLarge`}
              key={id}
            >
              <Button
                id={id}
                onClick={onClick}
                className="buttonBottomMenu"
                icon={icon}
                label={icon === undefined ? label : undefined}
              />
            </div>
          );

        default:
          return (
            <div
              className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}
              key={id}
            >
              <Button
                id={id}
                onClick={onClick}
                className="buttonBottomMenu"
                icon={icon}
                label={icon === undefined ? label : undefined}
                disabled={disabled}
                iconClassName={disabled ? 'iconButtomMenuDisabled' : ''}
              />
            </div>
          );
      }
    } else {
      switch (activeMenu) {
        case APPDATA.AUTO_PROFILE_SETUP_TAB:
        case APPDATA.AUTO_PROFILE_STATUS_TAB:
        case APPDATA.AUTO_PROFILE_PARAMETERS_TAB:
        case APPDATA.VOLUME_SENSOR_CHART:
          return (
            <div
              className={`${APPSTYLE.COLUMN_2}colTitleButtomMenu`}
              key={id}
            >
              <div className="titleButtomMenu center">
                <span>{label}</span>
              </div>
            </div>
          );

        default:
          return (
            <div
              className={`${APPSTYLE.COLUMN_3}colTitleButtomMenu`}
              key={id}
            >
              <div className="titleButtomMenu center">
                <span>{label}</span>
              </div>
            </div>
          );
      }
    }
  };

  genereteBottomMenu = (buttonParam) => {
    const {buttonProps, activeId} = buttonParam;

    return (
      <div
        className="bottomMenu footer bottomMenu-show"
        id="bottom-menu"
      >
        {buttonProps.map((button, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            {this.generateButton(button.id, button.label, button.onClick, button.icon, activeId, button.disabled)}
          </Fragment>
        ))}
      </div>
    );
  };

  render() {
    const {buttonParam} = this.props;
    return this.genereteBottomMenu(buttonParam);
  }
}

BottomMenuCommon.propTypes = {
  activeMenu: PropTypes.string,
  buttonParam: PropTypes.shape({
    buttonProps: PropTypes.arrayOf(PropTypes.object),
    activeId: PropTypes.any,
  }),
};

BottomMenuCommon.defaultProps = {
  activeMenu: 'None',
  buttonParam: {},
};
